module.exports = __webpack_public_path__ + "3a6fb1179508a78304617d0c22a4afc2.jpg";